import { connectReservedTicketSelectionPage } from '../containers/ticketSelection/connectReservedTicketSelectionPage';
import ReservedTicketSelectionPage from '../containers/ticketSelection/ReservedTicketSelectionPage';

export default connectReservedTicketSelectionPage(ReservedTicketSelectionPage);
